import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./ValuesSection.css";

const ValuesSection = () => {
  const values = [
    "Clarté avant complexité",
    "Précision créative",
    "Succès partagé",
    "Calme sous pression",
  ];

  return (
    <section id="about" className="values-section">
      {/* Background blur effects */}
      <div className="values-bg-blur blur-teal-rotated" />
      <h2 className="values-main-title">Ce qui nous motive</h2>

      <div className="values-container">
        <Swiper
          modules={[Pagination]}
          pagination={{ clickable: true }}
          className="values-swiper"
        >
          <SwiperSlide>
            <div className="values-card">
              <h3 className="values-title">Notre Vision</h3>
              <div className="values-content">
                <p className="values-slide-text">
                  Devenir le partenaire technologique incontournable pour les
                  entreprises qui souhaitent externaliser leur développement en
                  toute confiance. Transformer les idées en produits numériques,
                  livrer rapidement et débloquer les situations critiques avec
                  clarté et soin.
                </p>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="values-card">
              <h3 className="values-title">Notre Mission</h3>
              <div className="values-content">
                <p className="values-slide-text">
                  Aider les entreprises à concrétiser leurs projets digitaux
                  grâce à un accompagnement technique de haut niveau, réactif,
                  humain et visionnaire.
                </p>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="values-card">
              <h3 className="values-title">Nos Valeurs</h3>
              <div className="values-content">
                <div className="circle-animation circle-small" />
                <div className="circle-animation circle-large" />
                <div className="values-logo">
                  <img src="/images/logo-without-text.png" alt="Nestia Logo" />
                </div>
                <div className="value-tag value-tag-1">
                  <span>{values[0]}</span>
                </div>
                <div className="value-tag value-tag-2">
                  <span>{values[1]}</span>
                </div>
                <div className="value-tag value-tag-3">
                  <span>{values[2]}</span>
                </div>
                <div className="value-tag value-tag-4">
                  <span>{values[3]}</span>
                </div>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </section>
  );
};

export default ValuesSection;
